// components
import { EnvironmentProvider, NpsClient } from '@sdb/planning-ui';

// styles
import { StyledNpsClientBox } from './NpsClientDialog.styles';

// utils
import { t } from 'i18next';

export const NpsClientDialog = ({
  userId,
  tenantId
}: {
  userId: number;
  tenantId: string;
}) => {
  return (
    <StyledNpsClientBox>
      <EnvironmentProvider
        appName="planning"
        userId={String(userId)}
        tenantId={String(tenantId)}
      >
        <NpsClient
          labels={{
            cancel: t('npsDialog.cancel'),
            confirm: t('npsDialog.confirm'),
            likely: t('npsDialog.likely'),
            no: t('npsDialog.no'),
            notLikely: t('npsDialog.notLikely'),
            remarks: t('npsDialog.remarks'),
            submit: t('npsDialog.submit'),
            title: t('npsDialog.title'),
            yes: t('npsDialog.yes'),
            subTitle: t('npsDialog.subTitle'),
            later: t('npsDialog.later'),
            thanks: t('npsDialog.thanks'),
            improve: t('npsDialog.improve'),
            close: t('npsDialog.close')
          }}
        />
      </EnvironmentProvider>
    </StyledNpsClientBox>
  );
};
